import createGatewayClass from './lib/create_gateway_class';

export default createGatewayClass({
  send(customerId) {
    this._backend.simulateTweetResponse(customerId);
  },
});



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/tweet_gateway.js